import classNames from 'classnames';

import { useXLoginUrlQuery } from '@query';

import { getFromUrl } from '@shared/helpers/url';

import { SocialAuthButtonProps } from '../AuthModal';

const XAuthButton = ({ className, disabled, children }: SocialAuthButtonProps) => {
  const from = getFromUrl();

  const { data: xLoginUrl } = useXLoginUrlQuery(from || '', {
    enabled: !!from,
  });

  const isDisabled = disabled || !xLoginUrl?.meta.link;

  return (
    <a
      rel="noreferrer"
      onClick={(event) => {
        if (isDisabled) {
          event.preventDefault();
        }
      }}
      href={xLoginUrl?.meta.link}
      className={classNames(
        {
          'grayscale pointer-events-none opacity-40': isDisabled,
        },
        className,
      )}
    >
      {children}
    </a>
  );
};

export default XAuthButton;
